import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Bug 22 fix: Unified guest options used across all search components
export const GUEST_OPTIONS = [
  { value: 'any', label: { en: 'Any', pt: 'Qualquer' } },
  { value: '1', label: { en: '1 guest', pt: '1 hóspede' } },
  { value: '2', label: { en: '2 guests', pt: '2 hóspedes' } },
  { value: '3', label: { en: '3 guests', pt: '3 hóspedes' } },
  { value: '4', label: { en: '4 guests', pt: '4 hóspedes' } },
  { value: '5', label: { en: '5 guests', pt: '5 hóspedes' } },
  { value: '6', label: { en: '6 guests', pt: '6 hóspedes' } },
  { value: '7', label: { en: '7 guests', pt: '7 hóspedes' } },
  { value: '8', label: { en: '8 guests', pt: '8 hóspedes' } },
  { value: '10', label: { en: '10 guests', pt: '10 hóspedes' } },
  { value: '12', label: { en: '12 guests', pt: '12 hóspedes' } },
  { value: '14', label: { en: '14 guests', pt: '14 hóspedes' } },
  { value: '16', label: { en: '16+ guests', pt: '16+ hóspedes' } },
];

// Bug 22 fix: Format results count with proper plural
export function formatResultsCount(count, lang = 'en') {
  if (lang === 'pt' || lang.startsWith('pt')) {
    return count === 1 ? '1 propriedade encontrada' : `${count} propriedades encontradas`;
  }
  return count === 1 ? '1 property found' : `${count} properties found`;
}
